import { ModuleWidget, SOFTLINE_WIDGET_OUTLET_DASHBOARD } from '@softapps/core';
import {
  SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK_WIDGET,
  SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK_WIDGET_FULL_WIDTH,
} from './umsatzstatistik.shared';

// Widget registrations — loaded when a matching widget-outlet renders
// (federation) or re-provided via provideModuleWidgets by the legacy composition.
export function umsatzstatistikWidgets(): ModuleWidget[] {
  return [
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'wws',
      loadComponent: () =>
        import('./widgets/umsatzstatistik-widget/umsatzstatistik-widget.component').then(
          (m) => m.UmsatzstatistikWidgetComponent
        ),
      permission: SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK_WIDGET,
    },
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'wws',
      loadComponent: () =>
        import(
          './widgets/umsatzstatistik-full-width-widget/umsatzstatistik-full-width-widget.component'
        ).then((m) => m.UmsatzstatistikFullWidthWidgetComponent),
      permission: SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK_WIDGET_FULL_WIDTH,
    },
  ];
}
